/* Copyright 2013 - 2024 Waiterio LLC */
import DEVELOPMENT from './DEVELOPMENT.js'
import ENVIRONMENT from './ENVIRONMENT.js'

export default ENVIRONMENT === DEVELOPMENT
